<template>
  <div class="mt-8">
    <v-data-table
      :loading="tableLoading"
      :headers="headers"
      :items="items"
      :items-per-page="options.itemsPerPage"
      sort-by="check_date"
      sort-desc
      item-key="id"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 30, 60],
        'items-per-page-text': 'Տողեր մեկ էջի համար',
      }"
      class="elevation-0 mt-10"
      :options.sync="options"
      @update:options="getHistory"
      :server-items-length="totalRecords"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="0"
                outlined
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                Ներբեռնել աշխատանքը
              </v-btn>
            </template>

            <v-card class="pa-3">
              <v-card-text>
                <v-file-input
                  ref="file"
                  v-model="file"
                  counter
                  label="Ֆայլի մուտքագրում"
                  multiple
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  :show-size="1000"
                >
                </v-file-input>
                <v-text-field
                  prepend-icon="mdi-format-header-pound"
                  v-model="editedItem.title"
                  label="Վերնագիր"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="editedItem.author"
                  label="Հեղինակ"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-calendar-range"
                  v-model="editedItem.year"
                  type="number"
                  label="Տարի"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-city"
                  v-model="editedItem.publisher"
                  type="text"
                  label="Հրապարակման վայր"
                >
                </v-text-field>
                <v-autocomplete
                  prepend-icon="mdi-file-sign"
                  v-model="editedItem.category"
                  :items="categoryItems"
                  label="Աշխատանքի տեսակ"
                >
                </v-autocomplete>
                <v-checkbox
                  v-if="getEnableSynonymsDetection"
                  v-model="enableSynonymsDetection"
                  label="Միացնել հոմանիշների հայտնաբերումը"
                ></v-checkbox>
                <v-checkbox
                  v-if="getEnableTechnicalTrickDetection"
                  v-model="enableTechnicalTrickDetection"
                  label="Միացնել տեխնիկական հնարքների հայտնաբերումը"
                ></v-checkbox>
                <v-checkbox
                  v-model="EnableWebSearch"
                  label="Միացնել օնլայն բազաներից արտագրությունների հայտնաբերումը"
                ></v-checkbox>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  outlined
                  @click="changeFileInput(editedItem)"
                >
                  Շարունակել
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-toolbar>
      </template>
      <template v-slot:item.originality="{ item }">
        <v-chip
          v-if="item.originality || item.originality === 0"
          :color="getColor(item)"
        >
          {{ (item.originality * 100).toFixed(2) + "%" }}
        </v-chip>
        <v-chip v-else-if="item.status === 'Failed'" :color="getColor(item)"> Failed </v-chip>
        <v-progress-circular
          v-else-if="loading || (!item.originality && item.status !== 'Failed')"
          indeterminate
          color="red"
        ></v-progress-circular>
        <!-- <div class="pallete">
          <v-sheet
            
            height="50"
            width="70"
            class="d-flex ms-3 align-center justify-center muted--text font-weight-bold body-2"
            ></v-sheet
          >
        </div> -->


      </template>
      <template v-slot:item.original_filename="{ item }">
        <template
          v-if="
            item.original_filename.split('.').pop() === 'docx' ||
            item.original_filename.split('.').pop() === 'doc'
          "
        >
          <div class="d-flex align-center">
            <img src="@/assets/docx.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
        <template v-if="item.original_filename.split('.').pop() === 'pdf'">
          <div class="d-flex align-center">
            <img src="@/assets/pdf.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
        <template v-if="item.original_filename.split('.').pop() === 'txt'">
          <div class="d-flex align-center">
            <img src="@/assets/txt.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-btn :to="{ name: 'Result', params: { url: item.url } }" icon>
            <v-icon small> mdi-eye </v-icon>
          </v-btn>

          <v-icon
            :disabled="loading"
            small
            class="mr-2"
            @click="exportResults(item)"
          >
            mdi-download
          </v-icon>
          <v-icon small @click="deleteHistory(item)"> mdi-delete </v-icon>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import axios from "axios";

import { mapGetters } from "vuex";

export default {
  name: "Checkings",
  data: () => {
    return {
      url: process.env.VUE_APP_BACKEND_URL,
      tableLoading: false,
      totalRecords: null,
      loading: false,
      file: null,
      EnableWebSearch: false,
      headers: [
        { text: "Լոգին", value: "user_login", sortable: false },
        // { text: "Փաստաթուղթ", value: "document", sortable: false },
        {
          text: "Փաստաթղթի անվանումը",
          value: "original_filename",
          sortable: false,
        },
        { text: "Վերնագիր", value: "title", sortable: false },
        { text: "Հեղինակ", value: "author", sortable: false },
        { text: "Ստուգման ամսաթիվը", value: "year", sortable: false },
        { text: "Աշխատանքի տեսակ", value: "category", sortable: false },
        { text: "Հրապարակման վայր", value: "publisher", sortable: false },
        {
          text: "Բնօրինակության տոկոսը",
          value: "originality",
          sortable: false,
        },
        // { text: "Արդյունքներ", value: "results", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      items: [],
      dialog: false,
      options: {
        itemsPerPage: 5, // initialize itemsPerPage to a default value
        // page: 1,
      },
      // dialogDelete: false,
      editedIndex: -1,
      editedItem: {
        user_login: "",
        document: "",
        original_filename: "",
        title: "",
        author: "",
        year: new Date().getFullYear(),
        originality: "",
        publisher: "",
        category: "",
      },
      defaultItem: {
        user_login: "",
        document: "",
        original_filename: "",
        title: "",
        author: "",
        year: new Date().getFullYear(),
        originality: "",
        publisher: "",
        category: "",
      },

      categoryItems: [
        "դիպլոմային աշխատանք",
        "ատենախոսություն",
        "գիտական հոդված",
        "գիրք",
        "այլ",
      ],
      enableSynonymsDetection: false,
      enableTechnicalTrickDetection: false,
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    getEnableTechnicalTrickDetection() {
      return JSON.parse(localStorage.getItem("EnableTechnicalTrickDetection"));
    },
    getEnableSynonymsDetection() {
      return JSON.parse(localStorage.getItem("EnableSynonymsDetection"));
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  methods: {
    getDataFromApi() {
      this.tableLoading = true;
      this.getHistory();
    },
    getColor(item) {
      let score = (item.originality * 100).toFixed(2);
      if (score < 40) {
        return "error";
      }
      if (score >= 40 && score < 60) {
        console.log("warning");
        return "warning";
      }
      if (score >= 60 && score < 80) {
        return "yellow";
      }
      if (score >= 80 && score <= 100) {
        return "success";
      }
      if (item.originality === "Failed" || item.originality === "null") {
        return "error";
      }
      return "";
    },
    changeFileInput(item) {
      this.loading = true;

      let formData = new FormData();
      formData.append("file", this.file[0], this.file[0].name);
      formData.append(
        "ENABLE_SYNONYMS_DETECTION",
        this.enableSynonymsDetection
      );
      formData.append(
        "ENABLE_TECHNICAL_TRICK_DETECTION",
        this.enableTechnicalTrickDetection
      );
      formData.append("ENABLE_WEB_SEARCH", this.EnableWebSearch);
      formData.append("header", this.editedItem.title);
      formData.append("author", this.editedItem.author);
      formData.append("year", this.editedItem.year);
      formData.append("publisher", this.editedItem.publisher);
      formData.append("category", this.editedItem.category);

      fetch(`${this.url}/report`, {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then(async (data) => {
          this.editedItem.url = data.url;
          await this.getPlagiarismDetectionStatus(item);

        })
        .then(() => {
          this.getHistory();
          this.close();
        });
    },

    getPlagiarismDetectionStatus(item) {
      let checkInterval = setInterval(() => {
        fetch(`${this.url}/report/status/${item.url}`)
          .then((response) => response.text())
          .then((result) => {
            if (result === "Pending confirmation") {
              // console.log(result);
              clearInterval(checkInterval);
              this.getPlagiarismDetectionResults(item);
            } else if (result === "Failed") {
              clearInterval(checkInterval);
              item.originality = "Failed";
              this.loading = false;
              // console.log(item);
            }
          });
      }, 5000);
    },

    getPlagiarismDetectionResults(item) {
      fetch(`${this.url}/report/${item.url}`)
        .then((response) => response.json())
        .then((result) => {
          // console.log(result, 'result');
          // console.log(JSON.stringify(result.edit_report_dict, "report"))
          // console.log(result.report, "only report");
          let report = JSON.parse(result.report);
          item.originality = report.originality_score;
          // console.log(this.item);
          this.loading = false;
          this.getHistory();
        });
    },
    getHistory() {
      // const currentPage = this.$refs.dataTable.options.page;
      // const perPage = this.$refs.dataTable.options.itemsPerPage;

      let formdata = new FormData();
      formdata.append("page", this.options.page);
      formdata.append("per_page", this.options.itemsPerPage);
      formdata.append("filters", "[]");

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: this.getUser.jwt,
        },
        body: formdata,
        redirect: "follow",
      };

      fetch(`${this.url}/admin/history`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // console.log(result.history);
          this.items = [...result.history];
          this.items.forEach(item => {
            if (item.status === "Checking in process") {
              console.log(item)
              this.getPlagiarismDetectionStatus(item);
            }
          })
          this.totalRecords = result.count;
          this.tableLoading = false;
        })
        .catch((error) => console.log("error", error));

      // console.log(, "user")
      // console.log(typeof(this.getUser), 'type')
    },

    exportResults(item) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = `${this.url}/report/export/${item.url}`;
      link.download = "test";
      document.body.append(link);
      link.click();
    },

    deleteHistory(item) {
      // console.log(item);
      // const path = "/admin/history/delete";
      // console.log(item.url);
      const formData = new FormData();
      formData.append("url", item.url);
      const config = {
        method: "POST",
        headers: {
          // "content-type": "multipart/form-data",
          Authorization: this.getUser.jwt,
        },
        body: formData,
      };

      fetch(`${this.url}/admin/history/delete`, config)
        .then((response) => response.text())
        .then(() => this.getHistory())
        .catch((error) => console.log("error", error));
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.file = null;
      });
    },
  },

  mounted() {
    this.getHistory();
  },
};
</script>

